import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import moment from 'moment';
import { UserSession } from 'src/app/models/usersession';
import { NavigationService } from 'src/app/services/navigation.service';
import { NotificationService } from 'src/app/services/notification-service';
import { PromotionDataService } from 'src/app/services/promotion-data.service';
import { UserSessionService } from 'src/app/services/usersession.service';

@Component({
  selector: 'app-manage-relocation-promotion',
  templateUrl: './manage-relocation-promotion.component.html',
  styleUrls: ['./manage-relocation-promotion.component.scss']
})
export class ManageRelocationPromotionComponent implements OnInit {
  data: any[] = [];
  dataSource = new MatTableDataSource(this.data);
  isAdminView: Boolean = false;
  isAgentView: Boolean = true;
  accessDenied: Boolean = true;
  searchText: any;
  displayedColumns = ['agentName', 'link', 'customerNumber', 'applicationNumber', 'applicationStatus', 'promotionStatus', 'creditButton'];

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('searchInput', { static: false }) searchInput: ElementRef;

  filterValue: string = '';
  sessionDataString: any;

  constructor(
    private promotionService: PromotionDataService,
    private navigation: NavigationService,
    private toaster: NotificationService,
    private sessionService: UserSessionService
  ) {
    this.sessionDataString = JSON.parse(
      localStorage.getItem(this.sessionService.localStorageSessionKey)
    );
  }

  ngOnInit(): void {
    if (this.sessionDataString.roleId != 17) {
      this.promotionService.getRelocationPageAccessList().subscribe((res: any) => {
        if (res) {
          this.accessDenied = false;
          this.getTableData();
        }
        else {
          this.accessDenied = true;
        }
      });
    }
    else
      this.accessDenied = false;
  }

  getTableData() {
    this.promotionService.getRelocationPromotionDetails().subscribe((res: any) => {
      if (res?.isAdminModel) {
        this.isAdminView = true;
        this.isAgentView = false;
      }

      if(this.sessionDataString.roleId == 17)
        this.isAdminView = false;
        this.isAgentView = true;

      // directly use details array from the API response
      this.data = res?.details || [];

      // set up datasource
      this.dataSource = new MatTableDataSource(this.data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });
  }

  creditAmount(row: any) {
    debugger
    const payload = {
      applicationId: row.applicationId,
      applicationNumber: row.applicationNumber,
      applicationStatus: row.applicationStatusTypeName,
      retentionAgentUserId: row.agentUserId,
      userId: row.userId
    }
    this.promotionService.markRelocationPaymentAsPaid(payload).subscribe((res: any) => {
      if (res != null) {
        this.toaster.showSuccess('Payment marked as paid successfully');
        this.clearFilter();
      }
      else {
        this.toaster.showError('Failed to mark payment as paid');
      }
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterValue = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  clearFilter() {
    const inputElement = document.getElementById('filter-input') as HTMLInputElement;
    if (inputElement) {
      inputElement.value = '';
    }
    this.dataSource.filter = '';
    if (this.searchInput && this.searchInput.nativeElement) {
      this.searchInput.nativeElement.value = '';
    }
    // else {
    //   this.searchText = '';
    // }
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    this.getTableData();
  }

  onRefresh() {
    // this.searchText = '';
    this.getTableData();
  }

  generateLink() {
    this.navigation.goToRelocationPromotion();
  }

  exportToExcel() {
    this.promotionService.getRelocationExport(this.isAgentView).subscribe((Data) => {
      const linkSource = 'data:application/vnd.ms-excel;base64, ' + Data;
      const downloadLink = document.createElement('a');
      const fileName = "Relocation Retention Report - " + moment().format("DDMMYYYYHHmmss") + '.xlsx';
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    });
  }

  copyLink(link: string) {
    navigator.clipboard.writeText(link).then(() => {
      this.toaster.showSuccess('Link copied to clipboard');
    });
  }

  ngAfterViewInit() {
    debugger
    if (this.searchInput) {
      this.searchInput.nativeElement.value = '';
    }
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
    if (this.sort) {
      this.dataSource.sort = this.sort;
    }
  }

}
